/**
 * @flow
 */
import styled from 'react-emotion'
import { mobile, tablet } from '../../../utils/mixins'

export const CloseIconWrapper = styled('div')`
  user-select: none;
  cursor: pointer;
  position: absolute;
  left: 96%;
  top: 4%;
  ${mobile} {
    position: relative;
    left: 88%;
    padding: 10px;
    padding-bottom: 0px;
  }
  ${tablet} {
    left: 94%;
  }
`
export const VideoContainer = styled('div')`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  overflow: hidden;
`

export const YoutubeWrapper = styled('div')`
  margin-left: auto;
  margin-right: auto;
`



// WEBPACK FOOTER //
// ./src/components/common/VideoComponentModal/styledComponents.js